"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeoIntegrationModule = void 0;
class NeoIntegrationModule {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    async listAgreements() {
        const { data } = await this.axiosInstance.get("/api/v2/integrations/neo/");
        return data;
    }
    async login(username, password, idp) {
        const { data } = await this.axiosInstance.post("/api/v2/integrations/neo/login/", { username, password, idp });
        return data;
    }
}
exports.NeoIntegrationModule = NeoIntegrationModule;
//# sourceMappingURL=neo.js.map